export default new URL("../images/slide2.jpg", import.meta.url).href;